import { apiFetch } from './api';
import type { User } from '@/deploy/types';

export interface LoginPayload {
  token: string;
  expiresAt: string;
  user: User;
}

export const authService = {
  login: (email: string, password: string) =>
    apiFetch<LoginPayload>('/api/auth/login', {
      method: 'POST',
      json: { email, password },
    }),
  refresh: () => apiFetch<LoginPayload>('/api/auth/refresh', { method: 'POST' }),
  me: () => apiFetch<User>('/api/auth/me'),
};
